import { apiGroup } from '../http';

var _apiGroup = apiGroup({
  name: 'WebApi',
  dataOption: 'webApi',
  plural: {
    requiredOptions: [],
    url: function url(_ref) {
      var kappSlug = _ref.kappSlug;
      return kappSlug ? "/kapps/".concat(kappSlug, "/webApis") : "/webApis";
    },
    transform: function transform(response) {
      return {
        webApis: response.data.webApis
      };
    }
  },
  singular: {
    requiredOptions: ['slug'],
    url: function url(_ref2) {
      var slug = _ref2.slug,
          kappSlug = _ref2.kappSlug;
      return kappSlug ? "/kapps/".concat(kappSlug, "/webApis/").concat(slug) : "/webApis/".concat(slug);
    },
    transform: function transform(response) {
      return {
        webApi: response.data.webApi
      };
    }
  }
}),
    fetchWebApis = _apiGroup.fetchWebApis,
    fetchWebApi = _apiGroup.fetchWebApi,
    createWebApi = _apiGroup.createWebApi,
    updateWebApi = _apiGroup.updateWebApi,
    deleteWebApi = _apiGroup.deleteWebApi;

export { fetchWebApis, fetchWebApi, createWebApi, updateWebApi, deleteWebApi };